import React from 'react';

import { TableWrapperCard } from './styles';

const TableWrapper: React.FC = ({ children }) => {
  return <TableWrapperCard className="card my-4">{children}</TableWrapperCard>;
};

export default TableWrapper;
